import axios from 'axios'
import { AnyAction } from '@reduxjs/toolkit'

import { ReduxPromiseAction } from '../typedRedux/actionTypes'

export function fetchCurrentUser(): ReduxPromiseAction {
  return (dispatch) =>
    dispatch({
      type: 'CURRENT_USER_FETCH',
      payload: axios('/user/current_user'),
    })
}

export function fetchCurrentUserSilent(): ReduxPromiseAction {
  return (dispatch) =>
    dispatch({
      type: 'CURRENT_USER_SILENT_FETCH',
      payload: axios('/user/current_user'),
    })
}

function resetCurrentUserUpdated() {
  return {
    type: 'CURRENT_USER_RESET_UPDATED',
  }
}

export function updateCurrentUser(data: any): ReduxPromiseAction {
  return (dispatch) =>
    dispatch({
      type: 'CURRENT_USER_UPDATE',
      payload: axios.put('/user/current_user', data),
    }).then(() => setTimeout(() => dispatch(resetCurrentUserUpdated()), 3000))
}

export function signInUser(data: any): ReduxPromiseAction {
  return (dispatch) =>
    dispatch({
      type: 'USER_SIGN_IN',
      payload: axios.post('/users/sign_in.json', data, { baseURL: '/' }),
    })
}

export function registerUser(data: any): ReduxPromiseAction {
  return (dispatch) =>
    dispatch({
      type: 'USER_REGISTER',
      payload: axios.post('/users.json', data, { baseURL: '/' }),
    })
}

export function changePassword(data: any): ReduxPromiseAction {
  return (dispatch) =>
    dispatch({
      type: 'USER_CHANGE_PASSWORD',
      payload: axios.post('/users/password.json', data, { baseURL: '/' }),
    })
}

export function setReferredBy(referredById?: string, referralType?: string) {
  return {
    type: 'AUTH_SET_REFERRING_USER_ID',
    referredById,
    referralType,
  }
}

export function clearReferredBy() {
  return {
    type: 'AUTH_CLEAR_REFERRING_USER_ID',
  }
}

export function showAuthModal() {
  return {
    type: 'AUTH_MODAL_SHOW',
  }
}

export function hideAuthModal() {
  return {
    type: 'AUTH_MODAL_HIDE',
  }
}

export function setActionToReplay(action: AnyAction) {
  return {
    type: 'AUTH_SET_ACTION_TO_REPLAY',
    payload: action,
  }
}

export function facebookLoginPending() {
  return {
    type: 'AUTH_FACEBOOK_LOGIN_PENDING',
  }
}

export function facebookLoginFulfilled() {
  return {
    type: 'AUTH_FACEBOOK_LOGIN_FULFILLED',
  }
}

export function facebookLoginRejected() {
  return {
    type: 'AUTH_FACEBOOK_LOGIN_REJECTED',
  }
}
